import React from 'react';
import { ArrowRight, Coffee } from 'lucide-react';

interface WelcomeScreenProps {
  onStart: () => void;
  onSkip: () => void;
}

export default function WelcomeScreen({ onStart, onSkip }: WelcomeScreenProps) {
  return (
    <div className="text-center space-y-8">
      <div className="relative">
        <Coffee className="w-20 h-20 text-[#fda36b] mx-auto mb-6 animate-float" />
        <div className="absolute inset-0 bg-[#fda36b]/20 blur-xl rounded-full" />
      </div>

      <div className="space-y-4">
        <h2 className="text-4xl font-bold text-white">
          So… you're joining Bond? Bold move.
        </h2>
        <p className="text-xl text-white/80 leading-relaxed max-w-lg mx-auto">
          Before we send you coffee, let's figure out what kind of drinker you are. 
          Just 5 questions. No pressure. We're not building a dating profile… yet.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <button
          onClick={onStart}
          className="group inline-flex items-center gap-3 bg-[#fda36b] text-[#132947] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#fda36b]/90 transition-all duration-300 transform hover:scale-105"
        >
          Alright, let's do this
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
        
        <button
          onClick={onSkip}
          className="inline-flex items-center gap-2 text-white/80 hover:text-[#fda36b] transition-colors duration-300 px-6 py-3 rounded-lg border border-white/20 hover:border-[#fda36b]/30"
        >
          Skip the quiz, I know what I want
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}